import http from './http'

export function getCompanySettings() {
  return http.get('company/settings').then((res) => res.data)
}

export function updateCompanySettings(data) {
  return http.put('company/settings', data).then((res) => res.data)
}
